import React, { useState } from "react";
import { Link } from "react-router-dom";

import { t } from 'i18next';

const NavLinks = (isOpen) => {
    const [heading, setHeading] = useState("")
    const [open, setOpen] = useState(false);

    if (isOpen === true) {
        setOpen(false)
    }

    const handleIsOpen = () => {
        setOpen(!open)
    }
    
    const closeSideBar = () => {
        setOpen(false)
    }
    const links = [
        {name: t("header_homepage"), mainlink: "/", submenu:false,
            sublinks:[
            ]
        },
        {name: t("header_expo_intro"), mainlink: "/about/guide", submenu:true,
            sublinks:[{
                Head: t("header_expo_intro"),
                sublink: [{name:t("header_intro_guide"), link:"/about/guide"},
                {name: t("header_intro_schedule"), link: "/about/schedule"}
                ]}
            ]
        },
        {name: t("header_intro"), mainlink: "/about/seminar", submenu:true,
            sublinks:[{
                Head: t("header_intro"),
                sublink: [
                {name: t("header_intro_seminar"), link: "/about/seminar"},
                {name: t("header_intro_symposium"), link: "/about/symposium"},
                {name: t("header_intro_industrialseminar"), link: "/about/industrialseminar"},
                {name: t("header_intro_nobel"), link: "/about/nobel"},
                {name: t("header_intro_event"), link: "/about/event"},
                {name: t("header_intro_forum"), link: "/about/forum"}]}
            ]
        },
        {name: t("header_comp"), mainlink: "/exhibitor/company", submenu:true,
            sublinks:[{
                Head: t("header_comp"),
                sublink: [
                    {name:t("header_comp_booth"), link: "/exhibitor/boothmap"},
                    {name:t("header_comp_intro"), link: "/exhibitor/company"},
                    {name:t("header_comp_ask"), link: "/exhibitor/overview"},
                    {name:t("header_comp_sponsor"), link: "/exhibitor/companysponsor"},
                    {name:t("header_comp_venture"), link: "/exhibitor/venture_capital"}
                ]
            }]},
        {name: t("header_visit"), mainlink: "/visitor/guide", submenu: true,
            sublinks:[{
                Head: t("header_visit"),
                sublink: [
                    {name: t("header_visit_guide"), link: "/visitor/guide"},
                    {name: t("header_visit_booth"), link: "/visitor/boothmap"},
                    {name: t("header_visit_regi"), link: "/visitor/registration"},
                    // {name: t("header_visit_conversation"), link: "/visitor/conversation"}
                    //{name: t("header_visit_checkregi"), link: "/visitor/check_registration"},
                    // {name: t("header_visit_comp"), link: "/"},
                    // {name: t("header_visit_booth"), link: "/"}
                ]
            }]},
        {name: t("header_info"), mainlink: "/info/notice", submenu: true,
            sublinks: [{
                Head: t("header_info"),
                sublink: [
                    {name: t("header_info_notice"), link: "/info/notice"},
                    {name: t("header_info_FAQ"), link: "/info/FAQ"},
                    {name: t("header_info_press"), link: "/info/press"},
                    {name: t("header_info_gallery"), link: "/info/gallery"}
                ]
            }]},
        {name: t("header_direction"), mainlink: "/directions/map", submenu: true,
            sublinks: [{
                Head: t("header_direction"),
                sublink: [
                    {name: t("header_direction_map"), link: "/directions/map"},
                    {name: t("header_direction_hotel"), link: "/directions/hotel"},
                    {name: t("header_direction_bus"), link: "/directions/bus"}
                ]
            }]}
    ];

    return (
        <>
            {
                links.map((link) => (
                    <div>
                        <div className="px-5 md:w-full lg:w-36 text-left md:cursor-pointer group">
                            <p className="py-4 justify-center grid-cols-2 box-content font-bold lg:text-xl hover:underline grid justify-between items-center md:pr-0 pr-5 whitespace-nowrap" onClick={() => heading !== link.name ? setHeading(link.name) : setHeading("")}>
                                <Link to={link.mainlink} className="hover:color-primary">{link.name}</Link><span className="text-xl text-right md:hidden md:mt-1 md:ml-2"><ion-icon name={`${heading === link.name ? "chevron-up" : "chevron-down"}`}></ion-icon></span>
                            </p>
                            {link.submenu && (
                                <div>
                                    <div className="absolute top-17 hidden group-hover:md:block hover:md:block z-10">
                                        <div className="py-3">
                                            <div className="w-4  h-4 left-3 absolute mt-1 bg-white rotate-45 z-10" style={{borderTop:"1px solid #DBDEE5",borderLeft:"1px solid #DBDEE5"}}></div>
                                        </div>
                                        <div className="bg-white p-3.5" style={{border:"1px solid #DBDEE5", width:"auto"}}>
                                            {
                                                link.sublinks.map((mysublinks) => (
                                                    <div>
                                                        {mysublinks.sublink.map(slink => (
                                                            <li className="text-base hover:underline text-gray-600 my-2.5">
                                                            <Link to={slink.link} className="hover:color-gray">{slink.name}</Link>
                                                            </li>
                                                        ))}
                                                    </div>
                                                ))
                                            }
                                        </div>
                                    </div>
                                </div>)}
                        </div>
                        {/* mobile view */}
                        <div className={`
                            ${heading === link.name ? 'md:hidden' : 'hidden'}
                        `}>
                            {link.submenu && link.sublinks.map((slinks) => (
                                    <div>
                                        <div>
                                            <div>
                                                {slinks.sublink.map(slink => (
                                                    <li className="py-3 pl-14">
                                                        <a href={slink.link}>{slink.name}</a>
                                                    </li>
                                                ))}
                                            </div>
                                        </div>
                                    </div>
                                ))}
                        </div>
                    </div>
                ))
            }
        </>
    )
}

export default NavLinks;